<template>
	<div class="page_ blue_">
		<p class="title_">
			{{ evaluationContent.createDate ? $t('hdetail.medicalRecordQuery2') : $t('hdetail.writeExperience') }}
		</p>
		<div class="con_">
			<div class="title">
				<span>{{ $t('hdetail.tit') }}：</span>
				<p @click.stop="clickRating">
					<span v-for="(item, index) in 5" :key="index" :class="isRating(index)" :data-index="index"></span>
				</p>
			</div>
			<div class="condet">
				<textarea
					name=""
					id=""
					cols="30"
					rows="10"
					:placeholder="$t('hdetail.placeHolder')"
					v-model="notedata"
					:disabled="!!evaluationContent.createDate"
				></textarea>
			</div>
			<div class="subsure" :class="{ on: ifanonymous === 0 }" @click="anonymous()">
				<label for=""></label>
				<span>{{ $t('hdetail.submit') }}</span>
			</div>
			<button @click="submit()" v-if="!evaluationContent.createDate">
				{{ $t('hdetail.submitBtn') }}
			</button>
		</div>
	</div>
</template>
<script>
import api from '@/utils/api';
export default {
	data() {
		return {
			evaluationContent: {},
			data: {
				star: -1,
				calimsId: this.$route.params.calimsId,
				ylClaimsid: this.$route.params.calimsId,
				desc: '',
				isAnonymous: 1,
				providerCode: this.$route.params.providerCode,
				providerName: this.$route.params.providerName
			},
			rating: 0,
			ifanonymous: 1,
			notedata: null
		};
	},
	mounted() {
		let evaluationContent = localStorage.getItem('evaluationContent');
		if (evaluationContent) {
			evaluationContent = JSON.parse(evaluationContent);
			this.rating = evaluationContent.star;
			this.data.star = evaluationContent.star;
			this.notedata = evaluationContent.desc;
			this.ifanonymous = evaluationContent.headImg ? 1 : 0;
		} else {
			evaluationContent = {};
		}
		this.evaluationContent = evaluationContent;
		if (this.$i18n.locale == 'zh-cn') {
			this.lanuage = 'CHINAESE';
		} else {
			this.lanuage = 'ENGLISH';
		}
	},
	methods: {
		anonymous() {
			if (this.evaluationContent.createDate) {
				return;
			}
			if (this.ifanonymous === 0) {
				this.ifanonymous = 1;
				this.data.isAnonymous = 1;
			} else {
				this.ifanonymous = 0;
				this.data.isAnonymous = 0;
			}
		},
		isRating(index) {
			++index;
			return index <= this.rating ? 'active' : '';
		},
		clickRating(event) {
			//查看评价
			if (this.evaluationContent.createDate) {
				return;
			}
			let mark = parseInt(event.target.dataset.index) + 1;
			this.rating = mark;
			this.$emit('starMarkChange', mark, this.outIndex);
			this.data.star = parseInt(event.target.dataset.index) + 1;
		},
		submit() {
			this.data.desc = this.notedata;
			this.data.lanuage = this.lanuage;
			api.getEvaluateInfo(this.data).then(res => {
				if (res.data.code === 200) {
					this.$message.success(res.data.msg);
					this.$router.back();
				}
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.page_ {
	position: relative;
	background-color: #fff;
	min-height: 80vh;
	border-radius: 10px;
	.title_ {
		padding: 20px 30px;
		font-weight: bold;
		font-size: 16px;
		border-bottom: 1px solid #f3f3f3;
		margin-bottom: 0;
	}
	.con_ {
		padding: 30px;
		font-size: 14px;
		.title {
			display: flex;
			align-items: center;
			font-size: 14px;
			p {
				display: flex;
				align-items: center;
				margin-bottom: 0;
				& > span {
					width: 18px;
					height: 17px;
					background: url(../assets/medilinkPC/star.png) center center no-repeat;
					background-size: contain;
					margin-right: 5px;
					&.active {
						background: url(../assets/medilinkPC/staron.png) center center no-repeat;
						background-size: contain;
					}
				}
			}
		}
		.condet {
			background-color: #fafafa;
			border-radius: 5px;
			padding: 10px 10px;
			height: 130px;
			margin: 20px 0 10px;
			textarea {
				width: 86.88%;
				height: 120px;
				outline: none;
				background-color: transparent;
				margin: 0 auto;
				border: none;
				resize: none;
				&::placeholder {
					color: #ccc;
					font-size: 13px;
				}
			}
		}
		.subsure {
			display: flex;
			align-items: center;
			label {
				width: 16px;
				height: 16px;
				border: 1px solid #ccc;
				margin-right: 10px;
			}
			&.on label {
				width: 16px;
				height: 16px;
				border: none;
				background: url(../assets/medilinkPC/checkiconr.png) center center no-repeat #2c5acc;
				background-size: 10px 10px;
				border-color: #2c5acc;
			}
		}
		button {
			height: 40px;
			line-height: 40px;
			width: 140px;
			background: #2c5acc;
			border-radius: 2px;
			text-align: center;
			font-size: 14px;
			color: #fff;
			margin: 20px 0;
			border: none;
			cursor: pointer;
			outline: 0;
		}
	}
}
</style>
